<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Code from 'dashboard/components/Code.vue';

const { t } = useI18n();
const store = useStore();
const route = useRoute();

const dialogRef = ref(null);
const chunksJson = ref('');

const open = async () => {
  dialogRef.value.open();
  try {
    const chunks = await store.dispatch(
      'captainResponses/chunksExport',
      route.params.assistantId
    );
    chunksJson.value = JSON.stringify(chunks, null, 2);
  } catch (error) {
    useAlert(t('CAPTAIN.RESPONSES.CHUNKS_DIALOG.ERROR_MESSAGE'));
    dialogRef.value.close();
  }
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CAPTAIN.RESPONSES.CHUNKS_DIALOG.TITLE')"
    :description="t('CAPTAIN.RESPONSES.CHUNKS_DIALOG.DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    width="3xl"
    overflow-y-auto
  >
    <Code :script="chunksJson" lang="json" />
    <template #footer />
  </Dialog>
</template>
